import { TFunction } from 'react-i18next';

export function errorCodeTranslation(
  t: TFunction,
  code: string,
  fallback?: string
): string {
  switch (code) {
    case 'operatorPlatform.at_least_one_tariff_rule_must_cover_present_and_future':
      return t(
        'cpo.atLeastOneTariffRuleMustCoverPresentAndFutur',
        'At least one tariff rule must cover the present and future.'
      );
    default:
      if (fallback) {
        return fallback;
      }

      return t(
        'cpo.genericError',
        'An error occurred while processing your request.'
      );
  }
}
